export enum CancellationPolicyCutoffUnit {
  HOURS = 'hours',
  DAYS = 'days',
  WEEKS = 'weeks',
}

export enum GuestCancellationBookingStatus {
  CANCELLABLE = 'cancellable',
  CANCELLED = 'cancelled',
  UNCANCELLABLE = 'uncancellable',
  DEADLINE_PASSED = 'deadline_passed',
}

export enum CancellationPolicyField {
  NOTES = 'notes',
}
